import BaseAdapter from './base';
import {AxiosResponse, AxiosError, AxiosRequestConfig} from 'axios';
import Letterbox from "@/models/Letterbox";
import store from "@/store";

export default class LetterboxAdapter extends BaseAdapter {

    request(options: AxiosRequestConfig): any {
        //Overwrite auth if logged in
        if (store.getters.isLoggedIn) {
            options.auth = {
                username: store.state.account.username,
                password: store.state.account.masterHash,
            };
        }
        return super.request(options);
    }

    public createLetterbox(payload: Letterbox): Promise<Letterbox> {
        return new Promise(((resolve, reject) => {
            const url = `/letterboxes`;
            this.request({
                method: 'post',
                data: payload,
                url,
            }).then( (res: AxiosResponse) => {
                resolve(Letterbox.from(res.data));
            }).catch((error: AxiosError) => {
                reject(error);
            });
        }));
    }

  public openLetterbox(id: string): Promise<Letterbox> {
    return new Promise(((resolve, reject) => {
      const url = `/letterboxes/${id}`;
      this.request({
        method: 'get',
        url,
      }).then( (res: AxiosResponse) => {
        resolve(Letterbox.from(res.data));
      }).catch((error: AxiosError) => {
        reject(error);
      });
    }));
  }

    public getLetterboxUploadInfo(uploadKey: string): Promise<Letterbox> {
        return new Promise(((resolve, reject) => {
            const url = `/letterboxes/info/${uploadKey}`;
            this.request({
                method: 'get',
                url,
            }).then( (res: AxiosResponse) => {
                resolve(Letterbox.from(res.data));
            }).catch((error: AxiosError) => {
                reject(error);
            });
        }));
    }
}
